import React from 'react';
import PopupWrapper from './PopupWrapper';

const DeletePopup = ({
  isOpen,
  onClose,
  removeID,
  content,
  onConfirm
}) => {

  const handleSubmit = (e) => {
    e.preventDefault();
    onConfirm(removeID);
  };

  return (
    <PopupWrapper
      isOpen={isOpen}
      onClose={onClose}
      isSmall={true}
    >
      <div className="text-center mb-4">
        {content}
      </div>

      <div className="popupButtons">
        <button
          type="button"
          onClick={onClose}
          className="cancel-btn p-3 grey-color"
        >
          Cancel
        </button>
        <button
          type="submit"
          onClick={handleSubmit}
          className="cancel-btn p-3"
        >
          Confirm
        </button>
      </div>
    </PopupWrapper>
  );
};

export default DeletePopup;